import Dropzone from 'react-dropzone';
import React, { useState } from 'react';
import {connect} from 'react-redux';
import Waypoint from 'react-waypoint';
import {UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap';

import {MediaAttachment} from "../../../../components/uploadgallery/MediaAttachment";
import { acceptableMimeTypes, primaryExtensionNames } from '../extensions';

const Progress = ({percentComplete}) => {
  return <div className="progress">
    <div className="progress-bar" role="progressbar" style={{width: (percentComplete || 0) + '%', textAlign: 'center'}}>
      {Math.round(percentComplete) || 0}%
    </div>
  </div>
}


/**
 * takes array<T> and returns array<array<T>> where the sub arrays are of max length size
 * @param list
 * @param size
 */
const grouped = (list, size) => {
  const result = [];
  list.forEach(x => {
    if (result.length === 0) {
      result.push([])
    }
    const current = result[result.length - 1];
    if (current.length < size) {
      current.push(x)
    } else {
      result.push([x])
    }
  });
  return result
}

const imageFillStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover'
}


export const UnconnectedUploadGallery = (({
  onSelect,
  existingFiles, loadMore, offset,
  uploadFile, deleteFile,
  activeTab, setActiveTab,
  isActive, progress, lastError, uploadedFiles
}) => {

  const [dropRejected, setDropRejected] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [searchText, setSearchText] = useState('');

  const galleryFiles = existingFiles;

  return <div className="upload-gallery">
    {
      lastError ? <div className="alert alert-danger">Oops! An error occurred during the upload</div> : undefined
    }
    {/* Uploader / Progress */}
    {
      isActive ? <div>
        <label>Upload progress</label>
        <Progress percentComplete={progress * 100}/>
        {
          progress === 1 ? <span><span className="fas fa-spinner fa-spin"/> Finalizing...</span> : undefined
        }
      </div> : <div>
        {
          dropRejected ? <div className="alert alert-danger alert-dismissable">
            File must be less than 15MB, an image or video, and one the following extensions: {
            primaryExtensionNames
              .map((x, i) => <span key={x}><code>{x}</code>{i === primaryExtensionNames.length - 1 ? '' : ', '}</span>)
          }
            <button type="button" className="close" onClick={() => setDropRejected(false)}>×</button>
          </div> : undefined
        }
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <a onClick={() => setActiveTab('gallery')} className={`nav-link ${activeTab === 'gallery' ? 'active' : ''}`}>Gallery</a>
          </li>
          <li className="nav-item">
            <a onClick={() => setActiveTab('upload')} className={`nav-link ${activeTab === 'upload' ? 'active' : ''}`}>Upload New Media</a>
          </li>
        </ul>
        <div className={'tab-content' + (activeTab === 'gallery' ? '' : ' d-none')} style={{minHeight: "400px"}}>

          {
            galleryFiles.length ? <div style={{
              marginTop: '20px', maxHeight: '870px',
              overflowY: 'auto', overflowX: 'hidden'
            }} className="container-fluid selector-gallery">
              <div style={{height: '50px'}}>
                <div className="input-group pull-right" style={{width: '200px'}}>
                  <span className="input-group-addon"><i className="far fa-search"></i></span>
                  <input type="text" className="form-control" placeholder="Filter results"
                         onChange={ e => setSearchText(e.target.value) }/>
                </div>
                { uploadedFiles.length ? <h5 style={{lineHeight: '50px'}}>Recently Uploaded:</h5> : '' }
              </div>
              {grouped(galleryFiles.filter(x => {
                return x.url.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
              }), 3).map((row, rowIndex) => {
                  return <div className="row" key={rowIndex}>{
                    row.map((media, mediaIndex) => {
                      let type = null
                      if (media.contentType.indexOf('image') === 0) {
                        type = 'Image'
                      } else if (media.contentType.indexOf('video') === 0) {
                        type = 'Video'
                      }

                      return (
                        <div className="col-sm-4" key={media._id ? media._id.$oid : 'new-upload'}>
                          <div className="card mb-4">
                            <div className={'card-body pr-2 pb-3' + (mediaIndex + rowIndex * 3 === selectedMedia ? ' selected' : '')}>
                              <div className="d-flex align-items-center">
                                <div className="item-caption w-100 text-truncate">{media.sourceFile}</div>
                                <UncontrolledDropdown className="mr-auto">
                                  <DropdownToggle color="default"><span className="ss-icon ss-ellipsisvertical"></span></DropdownToggle>
                                  <DropdownMenu>
                                    <DropdownItem onClick={() => {
                                      deleteFile(media._id.$oid)
                                    }}>
                                      <i className="fas fa-trash-alt" /> Delete
                                    </DropdownItem>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </div>
                            </div>
                            <div className={'card-img-top d-flex align-items-center ' + (onSelect ? ' selectable' : '')} style={{height: '180px', overflow: 'hidden' }}>
                              <MediaAttachment
                                key={media.url}
                                src={media.url}
                                imageStyle={imageFillStyle}
                                style={onSelect ? {cursor: 'pointer'} : {}}
                                onClick={() => onSelect && onSelect({
                                  url: media.url,
                                  type: type
                                }) && setSelectedMedia(mediaIndex + rowIndex * 3)}/>
                            </div>
                            <div className="card-body">

                              {onSelect ?
                                <button type="button" className="btn btn-secondary btn-block" onClick={() => onSelect({
                                  url: media.url,
                                  type: type
                                }) && setSelectedMedia(mediaIndex + rowIndex * 3)}>Select</button>
                                : ''}
                            </div>
                          </div>
                        </div>
                      )
                    })
                  }</div>

                }
              )
              }
              <div className="row">
                <Waypoint onEnter={() => (loadMore(offset))} bottomOffset={-100}/>
              </div>
            </div> : <h5 className="text-muted text-center" style={{marginTop: '20px'}}>No Media Found</h5>
          }
        </div>
        <div className={'tab-content' + (activeTab === 'upload' ? '' : ' d-none')} style={{paddingTop: '15px'}}>
          <Dropzone
            style={{width: '100%', border: '1px dashed #DDD', borderRadius: '3px', cursor: 'pointer'}}
            maxSize={1024 * 1024 * 15}
            accept={acceptableMimeTypes.join(', ')}
            onDropRejected={() => setDropRejected(true)}
            onDropAccepted={(f) => {
              const isImage = f[0].type.indexOf('image') === 0
              uploadFile(f[0], setSelectedMedia(0))
            }}
          >
          <span style={{display: 'block', textAlign: 'center', verticalAlign: 'middle', lineHeight: '200px'}}>
            Drop or click to upload an image or video
          </span>
          </Dropzone>
        </div>
      </div>
    }
  </div>
})

export const UploadGallery = connect(function mapStateToProps(state, ownProps) {
  const {isActive, progress, existingFiles, lastError, uploadedFiles, activeTab, offset} = state.chatter.publishing.fileUpload;
  return {
    ...ownProps,
    existingFiles,
    activeTab, setActiveTab: state.channel.chatter.publishing.setActiveTab.bind(state.channel.chatter.publishing),
    loadMore: state.channel.chatter.publishing.listUploads.bind(state.channel.chatter.publishing),
    deleteFile: state.channel.chatter.publishing.deleteFile.bind(state.channel.chatter.publishing),
    uploadFile: state.channel.chatter.publishing.startUpload.bind(state.channel.chatter.publishing),
    isActive, progress, lastError, uploadedFiles, offset
  }
})(UnconnectedUploadGallery);
